/**
 * 设备展示名 UI 映射：仅用于界面文案，不改写 equipmentData / 存储 / 匹配逻辑。
 * 键为 supportedDevices.data.ts 中的原始 displayname。
 *
 * 命名约定（supportedDevices.data.ts 共 97 个唯一 displayname）：
 * 总原则：版本号（V2/V3…）与级别词（Pro/Ultra/SE/Max/Master…）前须加空格且首字母大写。
 * - 基础型号为缩写代号（X87、DK68 等）连写保持原样
 * - 英文单词与数字连写须拆空格：SMART875 → SMART 875、Gamma75 → Gamma 75、Alpha6 → Alpha 6
 * - 版本连写：X75V2 → X75 V2、S9V2 Master → S9 V2 Master
 * - 级别连写：X23Pro → X23 Pro、S9Max → S9 Max、X23SE → X23 SE
 * - 连字符 Pro SKU 统一为空格展示：DK68-Pro → DK68 Pro、X75-Pro → X75 Pro
 * - 版本号大小写统一：S9 Pro v2 → S9 Pro V2
 */
const UI_DISPLAY_LABEL_MAP: Readonly<Record<string, string>> = {
  // 连字符 Pro SKU（配置表 3 条：DK68-Pro×1、X75-Pro×2）
  "DK68-Pro": "DK68 Pro",
  "X75-Pro": "X75 Pro",

  // 版本后缀 V2（配置表 2 条）
  X75V2: "X75 V2",

  // S9 V2 系列（配置表 8 条）
  "S9V2 Master": "S9 V2 Master",
  "S9V2 Master+": "S9 V2 Master+",
  "S9V2 Turbo": "S9 V2 Turbo",
  "S9V2 Ultimate": "S9 V2 Ultimate",

  // v2 大小写（配置表 4 条）
  "S9 Pro v2": "S9 Pro V2",
  "S9 Ultra v2": "S9 Ultra V2",

  // 级别连写（配置表 X23Pro×2、X23SE×2、S9Max×2；表中另有带空格的 X23 Pro / X23 SE / S9 Max 行）
  X23Pro: "X23 Pro",
  X23SE: "X23 SE",
  S9Max: "S9 Max",

  // 英文单词 + 数字连写（配置表 SMART875×2、Gamma75 系列、Alpha6×2、Alpha7×3、
  // battle68×1、DEEP68×1、DEEP80 MAX/Pro、Tank68 HE；Delta 上线后按同规则追加）
  SMART875: "SMART 875",
  Gamma75: "Gamma 75",
  "Gamma75 Pro": "Gamma 75 Pro",
  "Gamma75 Pro Evo": "Gamma 75 Pro Evo",
  "Gamma75 Ultra": "Gamma 75 Ultra",
  Alpha6: "Alpha 6",
  Alpha7: "Alpha 7",
  battle68: "Battle 68",
  DEEP68: "DEEP 68",
  "DEEP68 Pro": "DEEP 68 Pro",
  "DEEP80 MAX": "DEEP 80 MAX",
  "DEEP80 Pro": "DEEP 80 Pro",
  "Tank68 HE": "Tank 68 HE",

  "X98 (8K) Touch": "X98 Pro",
};

/** 将配置表 displayname 格式化为 UI 展示文案；未收录则原样返回。 */
export function formatDeviceDisplayLabel(raw: unknown): string {
  const s = String(raw ?? "").trim();
  if (!s) return s;
  return UI_DISPLAY_LABEL_MAP[s] ?? s;
}
